/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import { useThree } from "@react-three/fiber";

import { OrbitControls, useGLTF } from "@react-three/drei";
import { JazzLights } from "../Lights/JazzLights";
import { Trumpet } from "../Interactables/Trumpet";
import { Guitar } from "../Interactables/Guitar";
import { Piano } from "../Interactables/Piano";
import { Saxophone } from "../Interactables/Saxophone";
import { Violin } from "../Interactables/Violin";

export function JazzRoom(props) {
  const { nodes, materials } = useGLTF("/Jazz-transformed.glb");
  const { size, camera } = useThree();

  useEffect(() => {
    camera.position.set(100, 0, 100);
  }, []);

  camera.setViewOffset(
    size.width,
    size.height,
    50,
    -175,
    size.width,
    size.height
  );

  return (
    <group {...props} dispose={null}>
      <JazzLights />
      <OrbitControls
        // makeDefault
        // minDistance={1}
        // // originally 10 for min
        // maxDistance={50}
        // maxPolarAngle={Math.PI / 2}
        // // enablePan={false}
        minZoom={40}
        maxZoom={140}
        makeDefault
        minAzimuthAngle={0}
        maxAzimuthAngle={Math.PI / 2}
        minPolarAngle={Math.PI / 3}
        maxPolarAngle={Math.PI / 3}
        enableZoom={true}
        enablePan={true}
        zoomSpeed={0.3}
      />
      <Trumpet />
      <Guitar />
      <Piano />
      <Saxophone />
      <Violin />
      <mesh
        geometry={nodes.Plane.geometry}
        material={materials.PaletteMaterial001}
        position={[2.038, 5.929, 0.282]}
        rotation={[0, 1.562, 0]}
        scale={[1.087, 18.47, 1.087]}
        receiveShadow
      />
      <mesh
        geometry={nodes.trumpet_Circle006.geometry}
        material={materials.PaletteMaterial002}
        position={[5.735, 4.352, -3.425]}
        rotation={[Math.PI / 2, 0, -1.562]}
        scale={0.15}
        castShadow
        receiveShadow
      />
      <mesh
        geometry={nodes.Plane002.geometry}
        material={materials["Desk wood"]}
        position={[2.06, 0.667, 0.295]}
        scale={[1.05, 1, 1.05]}
        castShadow
        receiveShadow
      />
      <mesh
        geometry={nodes.Cube089.geometry}
        material={materials.Glass}
        position={[2.414, 3.605, -4.012]}
        rotation={[-Math.PI, 0.009, -Math.PI]}
        scale={[4.091, 8559757, 0.184]}
      />
      <mesh
        geometry={nodes.Floor.geometry}
        material={materials["Tiling Floor"]}
        position={[2.038, 0.327, 0.282]}
        rotation={[0, 1.562, 0]}
        scale={[4.35, 0.1, 4.35]}
        receiveShadow
      />
      <mesh
        geometry={nodes.Picture_Frame.geometry}
        material={materials.poster}
        position={[-0.115, 5.091, -3.675]}
        rotation={[Math.PI / 2, 0, 0.009]}
      />
      <mesh
        geometry={nodes.Picture_Frame001.geometry}
        material={materials.Material}
        position={[-0.115, 3.414, -3.675]}
        rotation={[Math.PI / 2, 0, 0.009]}
      />
      <mesh
        geometry={nodes.ground001.geometry}
        material={nodes.ground001.material}
        position={[-1.017, 0.439, 4.357]}
        rotation={[0, 1.562, 0]}
        scale={2.5}
      />
      <mesh
        geometry={nodes.plant001.geometry}
        material={materials.PaletteMaterial001}
        position={[-1.017, 0.439, 4.357]}
        rotation={[0, 1.562, 0]}
        scale={[2.5, 2.25, 2.5]}
        castShadow
        receiveShadow
      />
      <mesh
        geometry={nodes.Plane004.geometry}
        material={materials.screen}
        position={[-1.287, 2.979, 1.972]}
        rotation={[0, -0.009, 0]}
        scale={[0.241, 0.265, 0.289]}
      />
    </group>
  );
}

useGLTF.preload("/Jazz-transformed.glb");
